module.exports = __webpack_public_path__ + "img/dollar.98f8dfed.svg";